import { Controller } from "@hotwired/stimulus"

import { LIGHTBOX, OPEN_DIALOGS, neighbourFor, pathOf } from "../post_navigation/keys"

// The ← and → keys of a post page (phase 090, `doc/site-layout.md` 12.3):
// they follow the «Предыдущая запись» and «Следующая запись» links below the
// article, which are the navigation itself — without JavaScript, and on a
// phone, the links are all there is (no swipe). Which press acts is
// `neighbourFor`; the controller reads its facts and clicks the link, so Turbo
// Drive visits it exactly as a click would. A side the post does not have has
// no link, and its key does nothing. A press it acts on is not also left to
// scroll the page sideways; any other press is not touched.
export default class PostNavigationController extends Controller<HTMLElement> {
  static targets = ["previous", "next"]

  declare readonly previousTarget: HTMLAnchorElement
  declare readonly nextTarget: HTMLAnchorElement
  declare readonly hasPreviousTarget: boolean
  declare readonly hasNextTarget: boolean

  navigate(event: KeyboardEvent): void {
    const neighbour = neighbourFor({
      key: event.key,
      defaultPrevented: event.defaultPrevented,
      isComposing: event.isComposing,
      repeat: event.repeat,
      altKey: event.altKey,
      ctrlKey: event.ctrlKey,
      metaKey: event.metaKey,
      shiftKey: event.shiftKey,
      target: pathOf(event.target instanceof Element ? event.target : null),
      focus: pathOf(document.activeElement),
      lightboxOpen: document.querySelector(LIGHTBOX) !== null,
      dialogOpen: document.querySelector(OPEN_DIALOGS) !== null,
    })
    const link = this.linkTo(neighbour)
    if (link === null) return

    event.preventDefault()
    link.click()
  }

  private linkTo(neighbour: string | null): HTMLAnchorElement | null {
    if (neighbour === "previous" && this.hasPreviousTarget) return this.previousTarget
    if (neighbour === "next" && this.hasNextTarget) return this.nextTarget
    return null
  }
}
